import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/contexts/CartContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { CustomerAuthProvider } from "@/contexts/CustomerAuthContext";
import LandingPage from "@/pages/LandingPage";
import HubPage from "@/pages/HubPage";
import OrderPage from "@/pages/customer/OrderPage";
import KitchenLogin from "@/pages/kitchen/KitchenLogin";
import KitchenDashboard from "@/pages/kitchen/KitchenDashboard";
import OrderStatus from "@/pages/customer/OrderStatus";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMenuEditor from "@/pages/admin/AdminMenuEditor";
import EmployeeLogin from "@/pages/employee/EmployeeLogin";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import AboutUs from "@/pages/AboutUs";
import Contact from "@/pages/Contact";
import FloatingCallButton from "@/components/FloatingCallButton";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <CustomerAuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/hub" element={<HubPage />} />
              <Route path="/order" element={<OrderPage />} />
              <Route path="/order/:brand" element={<OrderPage />} />
              <Route path="/order/status/:orderId" element={<OrderStatus />} />
              <Route path="/cart" element={<OrderPage initialCartOpen={true} />} />
              <Route path="/kitchen/login" element={<KitchenLogin />} />
              <Route path="/kitchen" element={<KitchenDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/menu-editor" element={<AdminMenuEditor />} />
              <Route path="/employee" element={<EmployeeLogin />} />
              <Route path="/instore" element={<EmployeeLogin />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
            <FloatingCallButton />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </CustomerAuthProvider>
    </AuthProvider>
  );
}

export default App;
